<template>
  <div>
    <div class="tiao">
      <h1>How Can We help?</h1>
      <ul class="fa">
        <li >
            <router-link to="/A"> What currency you use?</router-link>
        </li>
        <li>
           <router-link to="/B">Can I pay by cash?</router-link>
        </li>
        <li>
           <router-link to="/C">I didn't get a verification code?</router-link>
        </li>
        <li>
          <router-link to="/D">The Services</router-link>
        </li>
        <li>
           <router-link to="/E">Use of the Services</router-link>
        </li>
        <li>
           <router-link to="/F">Cancellation Policy?</router-link>
        </li>
        <li>
           <router-link to="/G">Privacy and Security</router-link>
        </li>
        <li>
          <router-link to="/H">Terms & Conditions</router-link>
        </li>
        <li>
           <router-link to="/K">About us</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default{
    methods:{
        loa(){
            this.$route.push()
        }
    }
}
</script>
<style >
* {
  margin: 0px;
  padding: 0px;
}
.tiao {
  width: 100%;
}
.fa li {
  text-align: left;
  margin: 20px 40px;
  list-style-type: none;
}
.fa li a {
  color: black;
  text-decoration: none;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/first.vue